/**
 * Admin page: Global-e merchant migration tools, portal actions, and open RMA JSON download/upload.
 */
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import supportedGlobalEEnvsStore from "./stores/supported-global-e-envs-store";
import BasePageLayout from "../../../components/layouts/base-page-layout/base-page-layout";
import EditorPageLayout from "../../../components/layouts/editor-page/editor-page-layout";
import MigrateGlobalePlatformCard from "./migrate-globale-platform-card";
import ReMigrateGlobalePlatformStoreCard from "./re-migrate-globale-platform-store-card";
import MigrateGlobaleShopifyPlatformCard from "./migrate-globale-shopify-platform-card";
import ActivateGlobaleStoreCard from "./activate-globale-store-card";
import RMAsJsonDownloadUploadCard from "./rmas-json-download-upload-card";
import TriggerRmasImportCard from "./trigger-rmas-import-card";
import PlatformTransformationCard from "./platform-transformation-card";
import "./migrate-global-e-merchants.scss";

const AdminMigrateGlobalEMerchants: React.FC = observer(() => {
    useEffect(() => {
        void supportedGlobalEEnvsStore.fetchSupportedEnvironments();
    }, []);

    return (
            <BasePageLayout title="Migrate Global-E Merchants">
                <EditorPageLayout
                    toolbar={{
                        hasBack: false,
                        hasLocalesSelector: false,
                    }}
                >

                    <div className='migrate-global-e-merchants'>

                        <MigrateGlobalePlatformCard />
                        <ReMigrateGlobalePlatformStoreCard />
                        <MigrateGlobaleShopifyPlatformCard />
                        <ActivateGlobaleStoreCard />
                        <PlatformTransformationCard />
                        <RMAsJsonDownloadUploadCard />
                        <TriggerRmasImportCard />
                    </div>

                </EditorPageLayout>
            </BasePageLayout>
    );
});

export default AdminMigrateGlobalEMerchants;
